<div class="container-fluid spacer-top-navigation">
  <div class="container">
    <div class="row">
      <div class="col-12 pl-md-1 pr-md-1">
        <div class="tile">
          <h5 class="mb-2">{{ 'my-home.multi-order-strategies-landing-page.headline' | transloco }}</h5>
          <p class="mb-0">{{ 'my-home.multi-order-strategies-landing-page.text' | transloco }}</p>
        </div>
      </div>
    </div>
    <div class="row">
      @if (discoverFacade.multiOrderStrategiesLoading$ | async) {
        @for (shimmer of [1, 2, 3, 4, 5, 6, 7, 8]; track $index) {
          <div class="col-12 col-md-6 col-lg-3 pl-md-1 pr-md-1">
            <div class="loading-shimmer multi-order-strategy"></div>
          </div>
        }
      } @else {
        @if (discoverFacade.multiOrderStrategies$ | async; as strategies) {
          @for (strategy of strategies; track $index) {
            <div class="col-12 col-md-6 col-lg-3 pl-md-1 pr-md-1">
              <home-multi-order-strategy-card [strategy]="strategy" />
            </div>
          }
        }
      }
    </div>
  </div>
</div>
